export const EmailResetPasswordNC = {
	methods: {
		postPasswordResetNC(response) {
			if (response.status == 204) {
				this.show_resend_link_section = true;
				this.$notify.success({
					title: "Success",
					message: "Success"
				});
			}
		},
		postRsendPasswordResetLinkNC(response) {
			if (response.status == 204) {
				this.$notify.success({
					title: "Success",
					message: "Success"
				});
				this.show_disabled_link = true;
				setTimeout(
					function(self) {
						self.show_disabled_link = false;
					},
					60000,
					this
				);
			}
		}
	}
};
